import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  ACCESS_STATISTICS_LIST_GET,
  ACTIVITY_LIST_GET,
  ACTIVITY_STATISTICS_LIST_GET,
  CATEGORY_LIST_GET,
  CATEGORY_STATISTICS_LIST_GET,
  COURSE_STATISTICS_LIST_GET,
  LAST_CACHE_INVALIDATE_GET,
  LOGS_LIST_GET,
  TUTOR_LIST_GET,
  TUTOR_STATISTICS_LIST_GET,
} from '../actions/supervisorStats';

const initialState = {
  //*CHARTS
  charts: {
    accesses: {
      currently_active_users: 0,
      list: [],
      cache_tag: '',
    },
    activities: {
      total_activity: 0,
      total_activity_by_date: 0,
      list: [],
      cache_tag: '',
    },
    categories: {
      count_category: 0,
      list: [],
      cache_tag: '',
    },
    courses: {
      count_courses: 0,
      list: [],
      cache_tag: '',
    },
    tutors: {
      list: [],
      cache_tag: '',
    },
    last_update: {},
  },
  //^LISTS
  lists: {
    activities: {
      count_activities: 0,
      list: [],
      filters: {},
      pager: {},
    },
    categories: {
      count_category: 0,
      list: [],
      pager: {},
    },
    tutors: {
      total_tutor: 0,
      tutors_by_region: 0,
      list: [],
      filters: {},
      pager: {},
    },
    logs: {
      list: [],
      filters: {},
      pager: {},
    },
  },
};

const supervisorStatsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      //*charts.accesses
      case ACCESS_STATISTICS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.charts.accesses.currently_active_users =
          response?.currently_active_users || 0;
        draft.charts.accesses.list = response?.accesses || [];
        draft.charts.accesses.cache_tag = response?.cache_tag || '';
        break;
      }

      //*charts.activities
      case ACTIVITY_STATISTICS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.charts.activities.total_activity = response?.total_activity || 0;
        draft.charts.activities.total_activity_by_date =
          response?.total_activity_by_date || 0;
        draft.charts.activities.list = response?.activities_by_categories || [];
        draft.charts.activities.cache_tag = response?.cache_tag || '';
        break;
      }

      //^lists.activities
      case ACTIVITY_LIST_GET._SUCCESS: {
        const { response, pager } = action;
        draft.lists.activities.count_activities =
          response?.items?.count_activities || 0;
        draft.lists.activities.list = response?.items?.activities || [];
        draft.lists.activities.filters = response?.filters || {};
        draft.lists.activities.pager = pager || {};
        break;
      }

      //*charts.categories
      case CATEGORY_STATISTICS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.charts.categories.count_category = response?.count_category || 0;
        draft.charts.categories.list = response?.categories || [];
        draft.charts.categories.cache_tag = response?.cache_tag || '';
        break;
      }

      //^lists.categories
      case CATEGORY_LIST_GET._SUCCESS: {
        const { response, pager } = action;
        draft.lists.categories.count_category = response?.count_category || 0;
        draft.lists.categories.list = response?.categories || [];
        draft.lists.categories.pager = pager || {};
        break;
      }

      //*charts.courses
      case COURSE_STATISTICS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.charts.courses.count_courses = response?.count_courses || 0;
        draft.charts.courses.list = response?.courses_by_filter || [];
        draft.charts.courses.cache_tag = response?.cache_tag || '';
        break;
      }

      //*charts.tutors
      case TUTOR_STATISTICS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.charts.tutors.list = response?.tutors_by_ffoo || [];
        draft.charts.tutors.cache_tag = response?.cache_tag || '';
        break;
      }

      //^lists.tutors
      case TUTOR_LIST_GET._SUCCESS: {
        const { response, pager, only_filters } = action;
        if (!only_filters) {
          draft.lists.tutors.list = response?.items?.tutors || [];
          draft.lists.tutors.pager = pager || {};
          draft.lists.tutors.total_tutor = response?.items?.total_tutor || 0;
          draft.lists.tutors.tutors_by_region =
            response?.items?.tutors_by_region || 0;
        }
        draft.lists.tutors.filters = response?.filters || {};
        break;
      }

      //^lists.logs
      case LOGS_LIST_GET._SUCCESS: {
        const { response, filters } = action;
        draft.lists.logs.list = filters?.filters_only
          ? []
          : response?.items || [];
        draft.lists.logs.filters = response?.filters || {};
        draft.lists.logs.pager = filters?.filters_only
          ? {}
          : response?.pager || {};
        break;
      }

      //*charts.*all*
      case LAST_CACHE_INVALIDATE_GET._SUCCESS: {
        const { response, cacheTag } = action;
        draft.charts.last_update[cacheTag] = response?.updated || null;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default supervisorStatsReducer;
